import dayjs from "dayjs"
import format from "dayjs/plugin/customParseFormat"
dayjs.extend(format)
/**
 *
 * @param time in twenty four hour format string
 * @returns time in 12 hour format string
 * @example 18:00:23 -> 6:00 PM
 * @author Malik Bagwala <malik.bagwala@vesatogo.com>
 */
function displayTime(time: string, precision: "minute" | "second" = "minute") {
  if (!time) return "--:--"
  const dateObj = dayjs(time, "HH:mm:ss")
  if (!dateObj.isValid()) return "--:--"
  return dateObj.format(`hh:${precision === "minute" ? "mm" : "mm:ss"} a`)
}

export default displayTime
